import dynamic from 'next/dynamic'

import { MenuBar } from '@features/myWriting/pages/StoryDetailPage/components/MenuBar'
import { Container } from '@components/Container'
import { StoryCoverSkeleton } from '@components/loadings/StoryCoverSkeleton'
import { StoryCharacterSkeleton } from '@components/loadings/StoryCharacterSkeleton'
import { StoryDetailPageProps } from './interface'
import { WithPayRankProps } from './components/PayRank/interface'
import { WithBookLinkProps } from './components/BookLink/interface'

const Cover = dynamic<unknown>(() =>
  import('@features/myWriting/pages/StoryDetailPage/components/Cover').then(
    v => v.Cover
  )
)
const Character = dynamic<unknown>(() =>
  import('@features/myWriting/pages/StoryDetailPage/components/Character').then(
    v => v.Character
  )
)
const PayRank = dynamic<WithPayRankProps>(() =>
  import('@features/myWriting/pages/StoryDetailPage/components/PayRank').then(
    v => v.PayRank
  )
)
const Introduction = dynamic<unknown>(() =>
  import(
    '@features/myWriting/pages/StoryDetailPage/components/Introduction'
  ).then(v => v.Introduction)
)
const BookLink = dynamic<WithBookLinkProps>(() =>
  import('./components/BookLink').then(v => v.BookLink)
)
const StoryField = dynamic<unknown>(() =>
  import('./components/StoryField').then(v => v.StoryField)
)
const ManageChapters = dynamic<unknown>(() =>
  import(
    '@features/myWriting/pages/StoryDetailPage/components/ManageChapters'
  ).then(v => v.ManageChapters)
)

export function StoryDetailPage({ isLoading }: StoryDetailPageProps) {
  return (
    <>
      <MenuBar />

      <Container className='mobile:my-0 mobile:!py-0 !pt-[30px] pb-[80px]'>
        {isLoading ? (
          <>
            <StoryCoverSkeleton />
            <StoryCharacterSkeleton className='mt-[20px]' />
          </>
        ) : (
          <>
            <Cover />
            <Character />
            <PayRank />
            <Introduction />
            <BookLink />
            <StoryField />
            <ManageChapters />
          </>
        )}
      </Container>
    </>
  )
}
